import { useMemo } from 'react';
import { withStyles, Icon, SelectRenderOptionArgs } from 'vopay';
import styles from './SelectOptionLocked.module.scss';
import { useLockedFeatureDialogue } from '../../../providers/LockedFeatureDialogue.provider';
import { useLockedFeatures } from '../../../providers/LockedFeatures.provider';

const classes = withStyles(styles);

type ComponentProps = SelectRenderOptionArgs & {
  onClick?: () => void;
  children: React.ReactNode;
  featureKey: string;
  disabled?: boolean;
};

function SelectOptionLocked({
  Option,
  SelectedIcon,
  children,
  onClick,
  preventDefault,
  selected,
  featureKey,
  disabled,
}: ComponentProps) {
  const { updateIsLocked } = useLockedFeatureDialogue();
  const { LockedSelectOptions } = useLockedFeatures();
  const locked = useMemo(() => LockedSelectOptions && featureKey in LockedSelectOptions, [LockedSelectOptions]);

  return (
    <Option
      onClick={() => {
        if (locked) {
          preventDefault();
          updateIsLocked(true, featureKey);
          onClick && onClick();
        } else if (disabled) {
          preventDefault();
          onClick && onClick();
        }
      }}
      className={classes((locked || disabled) && 'locked')}
    >
      <div className={classes('left')}>
        {locked && <Icon width="min-content" height="min-content" icon="lock2" size="sm" bgColor="primary-light" />}

        {children}
      </div>

      {selected && <SelectedIcon />}
    </Option>
  );
}

export default SelectOptionLocked;
